// vendor
import { Injectable } from '@angular/core';
import { catchError, map, switchMap, takeUntil } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'app/store/app.state';

// local application
import { AuthService } from 'app/services/auth.service';
import { AuthTypes } from './auth.type';
import * as authActions from './auth.action';
import { AuthModel } from './auth.model';
import { DialogActions } from 'app/store/global/dialog';
import { showSuccessNotificationDialogAction } from '../global/dialog/dialog.action';

@Injectable()
export class AuthEffects {
  constructor(
    private actions$: Actions,
    private service: AuthService,
    private store: Store<AppState>
  ) {}

  postLogin$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthTypes.POST_AUTH_LOGIN),
      switchMap((action: { payload: AuthModel }) =>
        this.service.login(action.payload).pipe(
          map(({ data }) => {
            localStorage.setItem('accessToken', data.details.token);
            const { token, ...userData } = data.details;
            localStorage.setItem('user', JSON.stringify(userData));
            return authActions.loginSuccess(data.details);
          }),
          takeUntil(
            this.actions$.pipe(ofType(AuthTypes.POST_AUTH_LOGIN_CANCEL))
          ),
          catchError((error: unknown) => {
            this.store.dispatch(authActions.loginCancel());
            return of(DialogActions.showErrorNotificationDialogAction(error));
          })
        )
      )
    )
  );

  postLogout$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthTypes.POST_AUTH_LOGOUT),
      switchMap(() =>
        this.service.logout().pipe(
          map((data) => {
            localStorage.clear();
            sessionStorage.clear();
            this.store.dispatch(showSuccessNotificationDialogAction(data));
            return authActions.logoutSuccess();
          }),
          catchError((error: unknown) => {
            return of(DialogActions.showErrorNotificationDialogAction(error));
          })
        )
      )
    )
  );

  getCompanyDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthTypes.GET_COMPANY_DETAILS),
      switchMap(({ payload }) =>
        this.service.getCompanyDetails(payload).pipe(
          map(({ data }) => {
            return authActions.getCompanyDetailsSuccess(data.detail);
          }),
          catchError((error: unknown) => {
            return of(DialogActions.showErrorNotificationDialogAction(error));
          })
        )
      )
    )
  );

  getKioskSettings$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthTypes.GET_COMPANY_KIOSK_SETTINGS),
      switchMap(({ payload }) =>
        this.service.getCompanyKioskSettings(payload).pipe(
          map(({ data }) => {
            return authActions.getCompanyKioskSettingsSuccess(data.detail);
          }),
          catchError((error: unknown) => {
            return of(DialogActions.showErrorNotificationDialogAction(error));
          })
        )
      )
    )
  );
}
